import MetadataForm from './MetadataForm'
export default MetadataForm
